import API_BASE_URL from '../config';
import React, { useState, useEffect,useMemo, act } from 'react';
import { Link } from 'react-router-dom';
import { GLOBAL_CALCULATIONS } from './GlobalLogic';
import { toast as toasty } from 'react-toastify';
import MainModalE from "./subcomponents/MainModalE";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area, Legend } from 'recharts';
import 'react-toastify/dist/ReactToastify.css';

const Dashboard = () => {
    const [orders, setOrders] = useState([]);
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [toast, setToast] = useState({ show: false, message: "" });
    const [payres, setPayres] = useState({});
    const [hiddenOrders, setHiddenOrders] = useState([]);
    const [fullypaidSearch,setFullypaidSearch] = useState("");

    const [modalon,setModalon] = useState(false);
        const [modalData, setModaldata] = useState({
                    items:{},
                    message:"Empty Message",
                    modalcallback: ()=>{}
                });

    const checkitems = {
        "6":{
            "Selling Price":"sellingprice",
            "On Road Expense":"fabricsourcing",
            "Fabric":"fabric",
            "Fabric Dye":"fabricdye",
            "Dupatta":"dupatta",
            "Dupatta Dye":"dupattadye",
            "Fabric Dispatch":"fabricdispatch",
            "Work":"work",
            "Unstitched Dispatch":"unstitcheddispatch",
            "Stitching":"stitching",
            "Lases":"lases",
            "Stitched Dispatch":"stitcheddispatch",
            "Packaging Cost":"packagingcost",
            "Package Dispatch":"packagedispatched",
            "Courrier Fee":"courierfee"

        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
    try {
        setLoading(true);
        await GLOBAL_CALCULATIONS.initializeData();
        setOrders(GLOBAL_CALCULATIONS.allOrders);
        setArticles(GLOBAL_CALCULATIONS.allArticles);
    } catch (error) {
        console.error("Dashboard Fetch Error:", error);
    } finally {
        setLoading(false);
    }
};

    const handleStatusChange = async (orderId, newStatus) => {
        if (!window.confirm(`Move order to ${newStatus}?`)) return;

        try {
            const response = await fetch(`${API_BASE_URL}/update-order-status/${orderId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    odrsts: newStatus, 
                    odrtrack: "", 
                    trackpart: "" 
                })
            });

            if (response.ok) {
                setOrders(prevOrders => 
                    prevOrders.map(order => 
                        order._id === orderId ? { ...order, odrsts: newStatus } : order
                    )
                );
                setToast({ show: true, message: `Status updated to ${newStatus}!` });
                setTimeout(() => setToast({ show: false, message: "" }), 3000);
            } else {
                alert("Server update failed.");
            }
        } catch (error) { 
            console.error("Network Error:", error);
        }
    };

    const daysSinceLastOrder = () => {
        if (!orders.length) return null;
        const lastOrderDate = new Date(Math.max(...orders.map(o => new Date(o.dateoforder))));
        const today = new Date();
        const diffTime = Math.abs(today - lastOrderDate);
        return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    };

    // Helper to calculate total internal cost from the order object itself
    const calculateOrderCost = (o) => {
    // 1. Basic Production Costs
    const productionCost = 
        (Number(o.fabric) || 0) +
        (Number(o.fabricdye) || 0) + 
        (Number(o.work) || 0) + 
        (Number(o.stitching) || 0) + 
        (Number(o.lases) || 0) + 
        (Number(o.dupatta) || 0) +
        (Number(o.dupattadye) || 0) +
        (Number(o.fabricdispatch) || 0) +
        (Number(o.unstitcheddispatch) || 0) +
        (Number(o.fabricsourcing) || 0) +
        (Number(o.stitcheddispatch) || 0) +
        (Number(o.packagingcost) || 0) + 
        (Number(o.packagedispatched) || 0) + 
        (Number(o.courierfee) || 0) + 
        (Number(o.extracost) || 0);

    // 2. Shipping Expenses (Money leaving your pocket)
    // We sum up the actual costs paid to Karigar, Courier, etc.
    const shippingExpenses = o.shipping_details ? (
        (Number(o.shipping_details.to_karigar) || 0) +
        (Number(o.shipping_details.to_sufna) || 0) +
        (Number(o.shipping_details.to_courier) || 0) +
        (Number(o.shipping_details.to_customer) || 0)
    ) : 0;

    // Total Cost = Production + Shipping Expenses
    return productionCost + shippingExpenses;
};

    const totalPendingFromCustomers = orders.reduce((sum, o) => {
        const balance = (Number(o.sellingprice) || 0) - (Number(o.payrec) || 0);
        return balance > 0 ? sum + balance : sum;
    }, 0);

const unpaidCustomers = useMemo(() => {
    const groupedMap = orders.reduce((acc, order) => {
        const name = (order.custname || "").trim();
        const instaId = (order.instaId || "").trim().toLowerCase();
        
        if ((order.odrsts === "Delivered" || order.delivered === true) || (!name && !instaId)) return acc;

        const compositeKey = `${name}_##_${instaId}`;

        const sellingPrice = Number(order.sellingprice) || 0;
        const paidReceived = Number(order.payrec) || 0;
        const currentPending = sellingPrice - paidReceived;
        
        // Calculate the internal production costs for this single order row
        const currentCost = GLOBAL_CALCULATIONS.getOrderInternalCost(order || {});

        if (!acc[compositeKey]) {
            acc[compositeKey] = {
                name: order.custname,
                instagramId: order.instaId,
                totalSellingPrice: 0,
                totalPayRec: 0,
                totalPending: 0,
                totalCost: 0,
                orderCount: 0
            };
        }

        acc[compositeKey].totalSellingPrice += sellingPrice;
        acc[compositeKey].totalPayRec += paidReceived;
        acc[compositeKey].totalPending += currentPending;
        acc[compositeKey].totalCost += currentCost;
        acc[compositeKey].orderCount += 1;

        return acc;
    }, {});

    return Object.values(groupedMap)
        .sort((a, b) => b.totalPending - a.totalPending)
        .slice(0, 30);
}, [orders]);
    const dashStats = unpaidCustomers.length || 10;

    const pendingProductionPayments = orders.reduce((acc, o) => {
        // Now using values directly from the order object
        if (!o.paystch) acc.stitching += (Number(o.stitching) || 0);
        if (!o.paygav) acc.karigar += (Number(o.work) || 0);
        return acc;
    }, { stitching: 0, karigar: 0 });

    const bestSellers = (() => {
        const stats = {};
        orders.forEach(o => {
            const name = o.articlename;
            if (!stats[name]) stats[name] = { count: 0, totalSP: 0, totalCost: 0, name: name };
            const cost = calculateOrderCost(o);
            stats[name].count += 1;
            stats[name].totalSP += (Number(o.sellingprice) || 0);
            stats[name].totalCost += cost;
        });
        return Object.values(stats)
            .map(item => ({ ...item, avgProfit: (item.totalSP - item.totalCost) / item.count }))
            .sort((a, b) => b.count - a.count).slice(0, dashStats);
    })();

    // Replace your pendingOrders with this:
const pendingOrders = useMemo(() => {
    return orders.filter(order => {
        const isNotFullyPaid = (Number(order.sellingprice) || 0) > (Number(order.payrec) || 0);
        const isKarigarPending = order.paygav === false;
        const isStitchingPending = order.paystch === false;
        const fullypaidquery = (fullypaidSearch || "").toLowerCase().trim();
        const matchsearch = !fullypaidquery || order.custname.toLowerCase().trim().includes(fullypaidquery);
        const pendignorder = isNotFullyPaid || isKarigarPending || isStitchingPending;
        return pendignorder && matchsearch;
    });
}, [orders,hiddenOrders,fullypaidSearch]); // Added dependency array


const handleToggle = async (order, field) => {
    let newValue;
    let oldValue = order[field];
    
    if (field === "payrec") {
        // Simple toggle: if fully paid, set to 0 (or previous), else set to full price
        newValue = (order.payrec === order.sellingprice) ? 0 : order.sellingprice;
        
        if (order.payrec === order.sellingprice) {
            if (!window.confirm(`Mark ${order.custname}'s payment as UNPAID?`)) return;
        }
    } else {
        newValue = !order[field];
    }

    // 1. Update UI Immediately
    // setOrders(prevOrders => 
    //     prevOrders.map(item => 
    //         item._id === order._id ? { ...item, [field]: newValue } : item
    //     )
    // );

    // 2. Logic for Hiding (Delay Logic)
    const willBeFullyPaid = (field === 'paygav' ? newValue : order.paygav) && 
                           (field === 'paystch' ? newValue : order.paystch) && 
                           (field === 'payrec' ? newValue === order.sellingprice : order.payrec === order.sellingprice);

    if (willBeFullyPaid) {
        setTimeout(() => {
            setHiddenOrders(prev => [...prev, order._id]);
        }, 1500); // Changed from 150000 to 1.5 seconds
    } else {
        setHiddenOrders(prev => prev.filter(id => id !== order._id));
    }

    // 3. API Call
    try {
        const response = await fetch(`${API_BASE_URL}/update-order-status/${order._id}`, {
            method: "PUT",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ [field]: newValue })
        });
        if (response.ok){
            setOrders(prevOrders => 
                prevOrders.map(item => 
                item._id === order._id ? { ...item, [field]: newValue } : item
                )
            );
            toasty.success(`Mark as Paid ${field}: ${newValue}`);
        }else{
                throw new Error();
        }
    } catch (error) {
        // fetchData(); // Rollback by refetching or manual revert
        setOrders(prevOrders => 
        prevOrders.map(item => 
            item._id === order._id ? { ...item, [field]: oldValue } : item
        )
    );
        // alert("Server update failed.");
        toasty.error("Server update failed");
    }
};


    const statusPriority = { "On Hold": 1, "Ready To Ship": 2, "Stiching": 3, "Embroidery": 4, "Fabric Recieved": 5, "Order Confirmed": 6 };

    const activeOrders = orders
        .filter(o => statusPriority[o.odrsts]) 
        .sort((a, b) => {
            const dateA = new Date(a.dateofdelivery || '9999-12-31');
            const dateB = new Date(b.dateofdelivery || '9999-12-31');
            return (dateA - dateB !== 0) ? (dateA - dateB) : (statusPriority[a.odrsts] - statusPriority[b.odrsts]);
        });

    const formatDeliveryDate = (dateStr) => {
        if (!dateStr) return { day: "--", monthYear: "" };
        const date = new Date(dateStr);
        return { day: date.getDate(), monthYear: date.toLocaleDateString('en-IN', { month: 'short', year: '2-digit' }) };
    };

    function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

    const getDynamicMonthStats = (monthsAgo) => {
        const targetDate = new Date();
        targetDate.setMonth(targetDate.getMonth() - monthsAgo);
        const targetMonth = targetDate.getMonth();
        const targetYear = targetDate.getFullYear();
        
        const filtered = orders.filter(o => {
            const d = new Date(o.deliveredat?o.deliveredat:o.dateofdelivery);
            return d.getMonth() === targetMonth && d.getFullYear() === targetYear && o.delivered;
        });

        const totalonroad = filtered.reduce((sum, order) => {
            return sum + ((order.fabricsourcing || 0) + (order.fabricdispatch || 0) + (order.unstitcheddispatch || 0) + (order.stitcheddispatch || 0) + (order.packagedispatched || 0));
        }, 0);

        const onTimeCount = filtered.reduce((sum, order) => {
            // 1. First, only check if the order status is 'Delivered'
            if (order.odrsts === 'Delivered') {
                const actualDelivery = new Date(order.deliveredat?order.deliveredat:order.dateofdelivery);
                const promisedDelivery = new Date(order.dateofdelivery); 

                // 2. Check if it was delivered on or before the promised time
                const isOnTime = actualDelivery <= promisedDelivery;

                return sum + (isOnTime ? 1 : 0);
            }
            // If order is not delivered, carry forward the current sum without adding anything
            return sum;
        }, 0);

        const gotorder = orders.filter(o =>{
            const d = new Date(o.dateoforder)
            return d.getMonth() === targetMonth && d.getFullYear() === targetYear && o.dateoforder
        })

        const grossProfit = filtered.reduce((sum, o) => {
            const cost = calculateOrderCost(o);
            return sum + (Number(o.sellingprice) - cost);
        }, 0);

        let totalPromoCost = 0;
        articles.forEach(art => {
            if (art.promotions && Array.isArray(art.promotions)) {
                art.promotions.forEach(p => {
                    const promoDate = new Date(p.date);
                    if (promoDate.getMonth() === targetMonth && promoDate.getFullYear() === targetYear) {
                        totalPromoCost += (Number(p.cost) || 0);
                    }
                });
            }
        });

        const netProfit = grossProfit - totalPromoCost;

        return { 
            total: netProfit,
            onroadtotal:totalonroad,
            ontimecount:onTimeCount,
            avg: filtered.length > 0 ? (netProfit / filtered.length) : 0, 
            count: filtered.length,
            getorder:gotorder.length,
            name: targetDate.toLocaleString('default', { month: 'long' }), 
            year: targetYear,
            month:targetMonth
        };
    };
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status"></div>
                    <div className="mt-2 fw-bold text-muted">Fetching Dashboard Data...</div>
                </div>
            </div>
        );
    }

    const cards = [getDynamicMonthStats(0), getDynamicMonthStats(1), getDynamicMonthStats(2), getDynamicMonthStats(3)];
    // const trendUp = cards[0].total >= cards[1].total;
    const todayDate = new Date();
    const trendUp = cards[0].total/todayDate.getDate() >= cards[1].total/daysInMonth(cards[1].month+1,cards[1].year);
    const trendpercent =  (((cards[0].total/todayDate.getDate())/(cards[1].total/daysInMonth(cards[1].month+1,cards[1].year)))*100).toFixed(2)
    const lastOrderDays = daysSinceLastOrder();

        const onmodalinfo = (item, modalfunction) => {
    // 1. Map entries directly into a clean, readable list string
    const modalmessage = `${item.custname}'s ${item.articlename}`;

    // 2. Dynamically build the items object with keys and values
    const modalItemsObject = {};
    Object.entries(checkitems[6] || {}).forEach(([key, value]) => {
        modalItemsObject[key] = item[value];
    });

    // 3. Pass both the built object and the message into the state
    setModaldata({
        items: modalItemsObject, // Stores { key1: item[value1], key2: item[value2], ... }
        message: modalmessage,
        modalcallback: modalfunction,
        modalitem:item
    });
    setModalon(true);
};

const closemodal = ()=>{
    setModalon(false);
}
    // console.log(cards[0].total/todayDate.getDate());

    return (
        <div className="container mt-4 mb-5 position-relative">
            {toast.show && (
                <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 11 }}>
                    <div className="toast show align-items-center text-white bg-success border-0 shadow" role="alert">
                        <div className="d-flex">
                            <div className="toast-body fw-bold">✅ {toast.message}</div>
                        </div>
                    </div>
                </div>
            )}

            <style>
                {`
                    @keyframes pulse-border {
                        0% { box-shadow: 0 0 0 0px rgba(13, 110, 253, 0.4); }
                        70% { box-shadow: 0 0 0 10px rgba(13, 110, 253, 0); }
                        100% { box-shadow: 0 0 0 0px rgba(13, 110, 253, 0); }
                    }
                    @keyframes bell-ring {
                        0%, 100% { transform: rotate(0); }
                        10%, 30% { transform: rotate(15deg); }
                        20%, 40% { transform: rotate(-15deg); }
                    }
                    .ready-badge-pulse { animation: pulse-border 2s infinite; }
                    .bell-animate { display: inline-block; animation: bell-ring 1.5s infinite ease-in-out; transform-origin: top center; }
                    .date-day { font-size: 1.2rem; font-weight: 800; line-height: 1; }
                    .date-month { font-size: 0.65rem; text-transform: uppercase; font-weight: 700; opacity: 0.8; }
                    .status-btn-custom { font-size: 0.75rem; font-weight: bold; border-radius: 5px; }
                    .table-dashboard { font-size: 0.9rem; }
                    .chart-container { height: 320px; width: 100%; }
                    .toggle-btn { font-size: 0.7rem; padding: 4px 10px; font-weight: bold; border: none; }
                    .toggle-group { background: #f0f2f5; padding: 3px; border-radius: 50px; }
                    .btn-silence { font-size: 0.65rem; padding: 2px 6px; border: 1px solid #dc3545; color: #dc3545; background: transparent; border-radius: 4px; margin-left: 8px; }
                    .btn-silence:hover { background: #dc3545; color: white; }
                `}
            </style>

            <div className="row g-3 mb-2">
                {cards.map((data, index) => (
                    <div className="col-md-4 col-lg-3" key={index}>
    <div className={`card shadow-sm border-0 rounded-4 h-100 transition-all ${
        index === 0 
            ? 'bg-dark text-white' 
            : 'bg-white border border-light-subtle'
    }`}>
        <div className="card-body d-flex flex-column justify-content-between p-4">
            {/* Header Section */}
            <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className={`fw-semibold text-uppercase tracking-wider m-0 small ${
                        index === 0 ? 'text-white-50' : 'text-secondary'
                    }`}>
                        {data.name}
                    </h6>
                    {index === 0 && (
                        <span className={`badge d-flex align-items-center gap-1 px-2 py-1 rounded-pill ${
                            trendUp ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                        }`} style={{ fontSize: '0.75rem' }}>
                            {trendUp ? `▲ ${trendpercent}%` : `▼ ${trendpercent}%`} 
                        </span>
                    )}
                </div>

                {/* Main Metric */}
                <h2 className="mb-3 fw-bold tracking-tight">
                    ₹{data.total.toLocaleString()}
                </h2>
                
                {/* Secondary Header Note */}
                <p className={`small mb-4 ${index === 0 ? 'text-white-50' : 'text-muted'}`}>
                    Net Profit (After Promos)
                </p>
            </div>

            {/* Expanded Stats Grid */}
            <div className="mt-auto">
                <div className="row g-2 text-center mb-3">
                    <div className="col-6">
                        <div className={`p-2 rounded-3 ${index === 0 ? 'bg-white bg-opacity-10' : 'bg-light'}`}>
                            <span className="d-block text-uppercase text-muted extra-small fw-bold" style={{ fontSize: '0.65rem' }}>
                                On-Road Exp.
                            </span>
                            <span className="fw-semibold small">
                                ₹{(data.onroadtotal || 0).toLocaleString()}
                            </span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className={`p-2 rounded-3 ${index === 0 ? 'bg-white bg-opacity-10' : 'bg-light'}`}>
                            <span className="d-block text-uppercase text-muted extra-small fw-bold" style={{ fontSize: '0.65rem' }}>
                                Promos Used
                            </span>
                            <span className="fw-semibold small">
                                ₹{(data.promosThisMonth || 0).toLocaleString()}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Footer Logistics Info */}
                <div className={`pt-3 border-top small ${
                    index === 0 ? 'border-white border-opacity-20 text-white-50' : 'border-light-subtle text-muted'
                }`}>
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <span>Orders (Rec/Del):</span>
                        <span className={`fw-medium ${index === 0 ? 'text-white' : 'text-dark'}`}>
                            {data.getorder} / {data.count}
                        </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <span>On-Time Rate:</span>
                        <span className="badge bg-success bg-opacity-25 text-success fw-bold px-1.5 py-0.5" style={{ fontSize: '0.7rem' }}>
                            {`${((data.ontimecount/data.count)*100).toFixed(0)} % /  ${data.ontimecount}`}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>  
                ))}
            </div>

            {/* <div className="row g-3 mb-4">
                <div className="col-md-6">
                    <div className="card shadow-sm border-0 bg-light">
                        <div className="card-body d-flex justify-content-between align-items-center py-2">
                            <span className="small fw-bold text-muted text-uppercase">🧵 Approx Stitching Payment Pending</span>
                            <span className="fw-bold text-dark">₹{pendingProductionPayments.stitching.toLocaleString()}</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card shadow-sm border-0 bg-light">
                        <div className="card-body d-flex justify-content-between align-items-center py-2">
                            <span className="small fw-bold text-muted text-uppercase">🌸 Approx Karigar Payment Pending</span>
                            <span className="fw-bold text-dark">₹{pendingProductionPayments.karigar.toLocaleString()}</span>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white py-3 border-0 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div>
                        <h5 className="mb-0 fw-bold">📊 Performance Analytics</h5>
                        <div className={`small fw-bold d-flex align-items-center flex-wrap ${showWarning ? 'text-danger' : 'text-muted'}`}>
                            {showWarning && <span className="bell-animate me-1">🔔</span>}
                            {lastOrderDays === 0 ? "Latest order was today" : `Last order: ${lastOrderDays} day${lastOrderDays === 1 ? '' : 's'} ago`}
                            {showWarning && <button className="btn-silence" onClick={() => setIsSilenced(true)}>Silence</button>}
                        </div>
                    </div>
                    <div className="toggle-group shadow-sm d-flex">
                        {[7, 15, 45].map(d => (
                            <button key={d} className={`btn btn-sm rounded-pill toggle-btn ${chartDays === d ? 'btn-primary text-white' : 'text-muted'}`} onClick={() => setChartDays(d)}>{d}D</button>
                        ))}
                    </div>
                </div>
                <div className="card-body">
                    <div className="chart-container">
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={getChartData()}>
                                <defs>
                                    <linearGradient id="colorEarnings" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#198754" stopOpacity={0.2}/>
                                        <stop offset="95%" stopColor="#198754" stopOpacity={0}/>
                                    </linearGradient>
                                    <linearGradient id="colorOrders" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#0d6efd" stopOpacity={0.2}/>
                                        <stop offset="95%" stopColor="#0d6efd" stopOpacity={0}/>
                                    </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
                                <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{fontSize: 10}} />
                                <YAxis yAxisId="left" axisLine={false} tickLine={false} tick={{fontSize: 10}} label={{ value: 'Orders', angle: -90, position: 'insideLeft', fontSize: 10 }} />
                                <YAxis yAxisId="right" orientation="right" axisLine={false} tickLine={false} tick={{fontSize: 10}} label={{ value: 'Profit', angle: 90, position: 'insideRight', fontSize: 10 }} />
                                <Tooltip contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
                                <Legend verticalAlign="top" height={36}/>
                                <Area yAxisId="left" type="monotone" name="Orders" dataKey="orders" stroke="#0d6efd" fill="url(#colorOrders)" strokeWidth={2} />
                                <Area yAxisId="right" type="monotone" name="Profit (₹)" dataKey="earnings" stroke="#198754" fill="url(#colorEarnings)" strokeWidth={2} />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div> */}

            <div className="col-md-12 py-4">
    <div className="card shadow-sm border-0 border-start border-success border-4">
        {/* Header */}
        <div className="card-header bg-white d-flex flex-column flex-md-row justify-content-around align-items-md-center gap-3 py-3">
    {/* Title Section */}
    <div className="mb-0">
        <h5 className="fw-bold text-success-emphasis mb-0">Payment Tracking Dashboard</h5>
        <small className="text-muted">Manage pending work, stitching, and customer payments</small>
    </div>

    {/* Controls Section: Stacked on mobile, aligned on desktop */}
    <div className="d-flex flex-column gap-2 w-100" style={{ maxWidth: "600px" }}>
        
        {/* Badges Layout (Now positioned above the search bar) */}
        <div className="d-flex flex-wrap gap-2 justify-content-start justify-content-md-between">
            <span className="badge bg-info text-white fw-bold px-2 py-1.5 flex-grow-1 text-center">Work (Karigar)</span>
            <span className="badge bg-primary text-white fw-bold px-2 py-1.5 flex-grow-1 text-center">Stitching (Tailor)</span>
            <span className="badge bg-success text-white fw-bold px-2 py-1.5 flex-grow-1 text-center">Customer Pending</span>
        </div>

        {/* Simplified Search Input */}
        <div className="w-100">
            <input
                type="text"
                className="form-control form-control-sm bg-light border-secondary-subtle"
                placeholder="Search orders..."
                aria-label="Search orders"
                value={fullypaidSearch}
                onChange={(e)=>{setFullypaidSearch(e.target.value)}}
            />
        </div>
        
    </div>
</div>

        {/* List Body */}
        <div className="card-body p-0">
            <div className="table-responsive" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <ul className="list-group list-group-flush">
                    {pendingOrders
                            .filter(item => !hiddenOrders.includes(item._id)) // Only hide after the delay
                            .map((item, i) => {
                                const isFullyPaid = item.paygav && item.paystch && (item.payrec === item.sellingprice);
                        return (
                           <li 
                key={item._id || i} 
                className={`list-group-item list-group-item-action py-2 px-4 ${isFullyPaid ? 'bg-success-subtle opacity-75' : ''}`}
                style={{ 
                    transition: 'all 0.5s ease', // Smooth transition for color and opacity
                    borderLeft: isFullyPaid ? '8px solid #198754' : '4px solid transparent',
                    transform: isFullyPaid ? 'scale(0.98)' : 'scale(1)'
                }}
            >
                                <div className="row align-items-center">
                                    {/* Customer Details */}
                                    <div className="col-md-3" onClick={()=>onmodalinfo(item,()=>closemodal())}>
                                        <span className={`fw-bold d-block fs-6 ${isFullyPaid ? 'text-decoration-line-through text-muted' : 'text-dark'}`}>
                                            {item.custname}
                                        </span>
                                        <span className="text-muted small">Article: {item.articlename}</span>
                                    </div>

                                    {/* Work Toggle */}
                                    <div className="col-md-3 d-flex justify-content-center align-items-center border-start border-end">
                                        <div className="text-center me-3">
                                            <span className={`text-info fw-bold fs-6 d-block ${item.paygav ? 'text-decoration-line-through opacity-50' : ''}`}>₹{item.work}</span>
                                            <small className="text-muted">Work</small>
                                        </div>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" role="switch" checked={item.paygav} onChange={() => handleToggle(item, 'paygav')} />
                                        </div>
                                    </div>

                                    {/* Stitching Toggle */}
                                    <div className="col-md-3 d-flex justify-content-center align-items-center border-end">
                                        <div className="text-center me-3">
                                            <span className={`text-primary fw-bold fs-6 d-block ${item.paystch ? 'text-decoration-line-through opacity-50' : ''}`}>₹{item.stitching}</span>
                                            <small className="text-muted">Stitch</small>
                                        </div>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" role="switch" checked={item.paystch} onChange={() => handleToggle(item, 'paystch')} />
                                        </div>
                                    </div>

                                    {/* Customer Toggle */}
                                    <div className="col-md-3 d-flex justify-content-center align-items-center">
                                        <div className="text-center me-3">
                                            <span className={`fw-bold fs-6 d-block ${item.payrec === item.sellingprice ? 'text-muted text-decoration-line-through' : 'text-dark'}`}>
                                                ₹{item.payrec === item.sellingprice ? item.sellingprice : `${item.sellingprice} - ${item.payrec}`}
                                            </span>
                                            <small className={`fw-bold ${item.sellingprice === item.payrec ? "text-success" : "text-danger"}`}>
                                                {item.sellingprice === item.payrec ? `Clear` : `Due ₹${item.sellingprice - item.payrec}`}
                                            </small>
                                        </div>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" role="switch" checked={item.payrec === item.sellingprice} onChange={() => handleToggle(item, 'payrec')} />
                                        </div>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>

        {/* Footer with Financial Summary */}
        <div className="card-footer bg-light py-3 px-4">
            <div className="row align-items-center text-center">
                <div className="col-md-4 border-end text-start">
                    <span className="text-muted small d-block mb-1">Financial Summary</span>
                    <div className="d-flex flex-column gap-1">
                        <div className="d-flex justify-content-between small">
                            <span>Customer Dues:</span>
                            <span className="fw-bold text-success">₹{pendingOrders.reduce((acc, curr) => acc + (curr.payrec < curr.sellingprice ? (curr.sellingprice - curr.payrec) : 0), 0)}</span>
                        </div>
                        <div className="d-flex justify-content-between small">
                            <span>Outward Costs:</span>
                            <span className="fw-bold text-danger">₹{pendingOrders.reduce((acc, curr) => acc + (!curr.paygav ? curr.work : 0) + (!curr.paystch ? curr.stitching : 0), 0)}</span>
                        </div>
                        <hr className="my-1" />
                        <div className="d-flex justify-content-between">
                            <span className="fw-bold">Net Difference:</span>
                            <span className="fw-bold text-dark">
                                ₹{pendingOrders.reduce((acc, curr) => {
                                    const cust = curr.payrec < curr.sellingprice ? (curr.sellingprice - curr.payrec) : 0;
                                    const out = (!curr.paygav ? curr.work : 0) + (!curr.paystch ? curr.stitching : 0);
                                    return acc + (cust - out);
                                }, 0)}
                            </span>
                        </div>
                    </div>
                </div>
                
                <div className="col-md-8">
                    <div className="row">
                        <div className="col-md-4">
                            <span className="text-muted small d-block">WORK PENDING</span>
                            <span className="text-info fs-4 fw-bold">₹{pendingOrders.reduce((acc, curr) => acc + (!curr.paygav ? curr.work : 0), 0)}</span>
                        </div>
                        <div className="col-md-4">
                            <span className="text-muted small d-block">STITCH PENDING</span>
                            <span className="text-primary fs-4 fw-bold">₹{pendingOrders.reduce((acc, curr) => acc + (!curr.paystch ? curr.stitching : 0), 0)}</span>
                        </div>
                        <div className="col-md-4">
                            <span className="text-muted small d-block">CUST. DUES</span>
                            <span className="text-success fs-4 fw-bold">₹{pendingOrders.reduce((acc, curr) => acc + (curr.payrec < curr.sellingprice ? (curr.sellingprice - curr.payrec) : 0), 0)}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

            <div className="row g-3 mb-4">
    {/* Customer Payment Pending Panel */}
    <div className="col-md-6">
        <div className="card shadow-sm border-0 border-start border-warning border-4 h-100">
            <div className="card-header bg-white d-flex justify-content-between align-items-center py-3">
                <span className="fw-bold text-warning-emphasis">⚠️ Customer Payment Pending</span>
                <span className="badge bg-warning text-dark fw-bold px-3 py-2">Total: ₹{totalPendingFromCustomers.toLocaleString()}</span>
            </div>
            <div className="card-body p-0" style={{ overflowY: 'auto' }}>
                <ul className="list-group list-group-flush small">
                    {unpaidCustomers.map((cust, idx) => {
                        // 1. Core Financial Calculations
                        const overallProfit = cust.totalSellingPrice - cust.totalCost;
                        
                        // Calculate profit percentage (Handle division by zero gracefully)
                        const profitPercentage = cust.totalSellingPrice > 0 
                            ? Math.round((overallProfit / cust.totalSellingPrice) * 100) 
                            : 0;

                        // Calculate average profit per order
                        const avgProfitPerOrder = cust.orderCount > 0 
                            ? Math.round(overallProfit / cust.orderCount) 
                            : 0;

                        return (
                            <li key={idx} className="list-group-item d-flex justify-content-between align-items-center py-2 px-3">
                                <div className="d-flex flex-column text-truncate me-2">
                                    {/* Primary Row: Customer Name & Order Counter */}
                                    <div className="text-start text-truncate">
                                        <span className="fw-bold text-dark">{cust.name}</span>
                                        {cust.orderCount > 1 && (
                                            <span className="badge bg-secondary-subtle text-secondary-emphasis rounded-pill ms-2" style={{ fontSize: '0.65rem' }}>
                                                {cust.orderCount} active orders
                                            </span>
                                        )}
                                    </div>
                                    
                                    {/* Secondary Compact Metadata Metrics row */}
                                    <div className="d-flex flex-wrap gap-2 mt-1 text-muted" style={{ fontSize: '0.72rem' }}>
                                        <span>Sales: <strong className="text-dark">₹{cust.totalSellingPrice.toLocaleString()}</strong></span>
                                        <span className="text-secondary-subtle">|</span>
                                        <span>Cost: <strong className="text-dark">₹{cust.totalCost.toLocaleString()}</strong></span>
                                        <span className="text-secondary-subtle">|</span>
                                        <span>
                                            Profit: <strong className={overallProfit >= 0 ? "text-success" : "text-danger"}>
                                                ₹{overallProfit.toLocaleString()} ({profitPercentage}%)
                                            </strong>
                                        </span>
                                    </div>

                                    {/* Tiny Sub-row for multi-order context */}
                                    {cust.orderCount > 1 && (
                                        <div className="text-muted text-start style={{ fontSize: '0.65rem' }} mt-0.5">
                                            Avg. Profit/Order: <span className={avgProfitPerOrder >= 0 ? "text-success fw-medium" : "text-danger fw-medium"}>₹{avgProfitPerOrder.toLocaleString()}</span>
                                        </div>
                                    )}
                                </div>
                                
                                {/* Right-Aligned Pending Core Highlight metric */}
                                <div className="text-end flex-shrink-0">
                                    <span className="text-danger fw-extrabold fs-6">₹{cust.totalPending.toLocaleString()}</span>
                                    <div className="text-muted fw-semibold" style={{ fontSize: '0.65rem' }}>Pending</div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    </div>

    {/* Bestselling Articles Panel */}
    <div className="col-md-6">
        <div className="card shadow-sm border-0 border-start border-success border-4 h-100">
            <div className="card-header bg-white d-flex justify-content-between align-items-center py-3">
                <span className="fw-bold text-success-emphasis">🔥 Bestselling Articles</span>
                <span className="badge bg-success text-white fw-bold px-3 py-2">Profit Stats</span>
            </div>
            <div className="card-body p-0" style={{overflowY: 'auto' }}>
                <ul className="list-group list-group-flush small">
                    {bestSellers.map((item, i) => (
                        <li key={i} className="list-group-item d-flex justify-content-between align-items-center py-2 px-4">
                            <div>
                                <span className="fw-bold text-dark">{item.name}</span>
                                <span className="text-muted ms-2">({item.count} sold)</span>
                            </div>
                            <span className="text-success fw-bold fs-6">
                                ₹{Math.round(item.avgProfit).toLocaleString()}{' '}
                                <small className="text-muted fw-normal" style={{ fontSize: '0.7rem' }}>avg</small>
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    </div>
</div>



            <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white py-3">
                    <h5 className="mb-0 fw-bold">Production Pipeline <small className="text-muted">({activeOrders.length} In Progress)</small></h5>
                </div>
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0 table-dashboard">
                        <thead className="table-light text-nowrap">
                            <tr>
                                <th className="ps-4">Customer & Article</th>
                                <th>S.Price</th>
                                <th>Profit</th>
                                <th>Balance</th>
                                <th className="text-center">Order Status</th>
                                <th>Delivery Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activeOrders.map((order) => {
                                const internalTotal = calculateOrderCost(order);
                                const profit = (Number(order.sellingprice) || 0) - internalTotal;
                                const balance = (Number(order.sellingprice) || 0) - (Number(order.payrec) || 0);
                                const statusData = GLOBAL_CALCULATIONS.getRemainingDaysStatus(order.dateofdelivery, order.odrsts);
                                const isReady = order.odrsts === "Ready To Ship";
                                const dateInfo = formatDeliveryDate(order.dateofdelivery);

                                const getStatusColor = (status) => {
                                    switch(status) {
                                        case 'Fabric Recieved': return { bg: '#cff4fc', text: '#055160' };
                                        case 'Embroidery': return { bg: '#f3e5f5', text: '#7b1fa2' };
                                        case 'Stiching': return { bg: '#fff3cd', text: '#856404' };
                                        case 'Ready To Ship': return { bg: '#0d6efd', text: '#ffffff' };
                                        default: return { bg: '#f8f9fa', text: '#212529' };
                                    }
                                };
                                const sColor = getStatusColor(order.odrsts);

                                return (
                                    <tr key={order._id} className={isReady ? "table-primary" : ""}>
                                        <td className="ps-4" onClick={()=>onmodalinfo(order,()=>closemodal())}>
                                            <div className="fw-bold text-dark">{order.custname}</div>
                                            <div className="text-muted small" style={{fontSize: '0.75rem'}}>{order.articlename}</div>
                                        </td>
                                        <td><div className="fw-bold text-primary">₹{order.sellingprice}</div></td>
                                        <td><div className={`fw-bold ${profit.toFixed(2) >= 0 ? 'text-success' : 'text-danger'}`}>₹{profit.toFixed(2)}</div></td>
                                        <td><div className={`fw-bold ${balance.toFixed(2) > 0 ? 'text-warning' : 'text-muted'}`}>{balance.toFixed(2) > 0 ? `₹${balance.toFixed(2)}` : "Cleared"}</div></td>
                                        <td className="text-center">
                                            <div className="dropdown">
                                                <button className={`btn btn-sm dropdown-toggle status-btn-custom shadow-sm ${isReady ? 'ready-badge-pulse' : ''}`} type="button" data-bs-toggle="dropdown" style={{ backgroundColor: sColor.bg, color: sColor.text, width: '130px' }}>
                                                    {order.odrsts}
                                                </button>
                                                <ul className="dropdown-menu shadow border-0" style={{ fontSize: '13px' }}>
                                                    <li><button className="dropdown-item" onClick={() => handleStatusChange(order._id, "Order Confirmed")}>⚪ Order Confirmed</button></li>
                                                    <li><button className="dropdown-item" onClick={() => handleStatusChange(order._id, "Fabric Recieved")}>🔹 Fabric Received</button></li>
                                                    <li><button className="dropdown-item" onClick={() => handleStatusChange(order._id, "Embroidery")}>🪡 Embroidery</button></li>
                                                    <li><button className="dropdown-item" onClick={() => handleStatusChange(order._id, "Stiching")}>🧵 Stiching</button></li>
                                                    <li><button className="dropdown-item" onClick={() => handleStatusChange(order._id, "Ready To Ship")}>📦 Ready To Ship</button></li>
                                                    <li><hr className="dropdown-divider" /></li>
                                                    <li><button className="dropdown-item text-success fw-bold" onClick={() => handleStatusChange(order._id, "Delivered")}>🚚 Mark Delivered</button></li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center gap-2 px-2 py-1 rounded shadow-sm bg-white border" style={{ maxWidth: '160px' }}>
                                                <div className="text-center border-end pe-2" style={{minWidth: '45px'}}>
                                                    <div className="date-day">{dateInfo.day}</div>
                                                    <div className="date-month">{dateInfo.monthYear}</div>
                                                </div>
                                                <div className="small fw-bold" style={{ color: statusData.color, fontSize: '0.7rem' }}>
                                                    {order.odrsts === "Delivered" ? "Delivered" : statusData.text}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row g-2 text-center">
                <div className="col-4 col-md-2">
                    <Link to="/addorder" className="text-decoration-none h-100 d-block">
                        <div className="p-3 border rounded-3 bg-white shadow-sm h-100">
                            <div className="fs-3 mb-1">➕</div>
                            <div className="small fw-bold text-dark">New Order</div>
                        </div>
                    </Link>
                </div>
                <div className="col-4 col-md-2">
                    <Link to="/addarticle" className="text-decoration-none h-100 d-block">
                        <div className="p-3 border rounded-3 bg-white shadow-sm h-100">
                            <div className="fs-3 mb-1">🏷️</div>
                            <div className="small fw-bold text-dark">New Article</div>
                        </div>
                    </Link>
                </div>
                <div className="col-4 col-md-2">
                    <Link to="/orders" className="text-decoration-none h-100 d-block">
                        <div className="p-3 border rounded-3 bg-white shadow-sm h-100">
                            <div className="fs-3 mb-1">📋</div>
                            <div className="small fw-bold text-dark">All List</div>
                        </div>
                    </Link>
                </div>

                <div className="col-6 col-md-3">
                    <div className="p-3 border rounded-3 bg-dark text-white shadow-sm h-100">
                        <div className="fs-3 mb-1 fw-bold">{articles.length}</div>
                        <div className="small fw-bold opacity-75">Total Articles</div>
                    </div>
                </div>
                <div className="col-6 col-md-3">
                    <div className="p-3 border rounded-3 bg-primary text-white shadow-sm h-100">
                        <div className="fs-3 mb-1 fw-bold">{orders.length}</div>
                        <div className="small fw-bold opacity-75">Total Orders</div>
                    </div>
                </div>
            </div>
            <MainModalE
    isopen={modalon}
    onclose={() => setModalon(false)}
    items={modalData.items}
    modalitem={modalData.modalitem}
    message = {modalData.message}
    okfunction = {() => {
        modalData.modalcallback();
        setModalon(false);
    }
    }
    />
        </div>
    );
};

export default Dashboard;
